import { ApolloProvider } from '@apollo/client'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import { appRoutes } from '@/appRoutes.tsx'
import { AlertModal } from '@/components/AlertModal.tsx'
import { UserProvider } from '@/contexts/UserContext.tsx'
import { apolloClient } from '@/requests/apollo/apolloConfig.ts'

import './index.css'
import { initializeCookieConsent } from '@/repositories/cookieConsentRepository.ts'
import { useEffect } from 'react'

export const App = () => {
  useEffect(() => {
    initializeCookieConsent()
  }, [])

  return (
    <>
      <AlertModal />
      <ApolloProvider client={apolloClient}>
        <UserProvider>
          <RouterProvider router={createBrowserRouter(appRoutes)} />
        </UserProvider>
      </ApolloProvider>
    </>
  )
}
